import { setBlockType } from 'common/Prose/Commands/setBlockType'
import { TEXT_STYLES } from 'common/Prose/constants'
import { computed } from 'mobx'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { ButtonHook } from '../Types'

export function useTextStyle(textStyleKey: keyof typeof TEXT_STYLES, view: EditorView): ButtonHook {
  const stateContext = useContext(AlmanacEditorStateContext)
  if (!stateContext) return { active: false, handleClick: () => {}, disabled: true }

  const { activeStyles } = stateContext
  const handleClick = () => {
    setBlockType(textStyleKey)(view.state, view.dispatch)
    view.focus()
  }

  const active = computed(() => activeStyles.has(textStyleKey)).get()

  return { active, handleClick, disabled: false }
}
